import Component from '@glimmer/component';

export default class CatalogSearchHelpComponent extends Component {
  <template>
    <div class="c-help" ...attributes>
      <p class="c-help__primary">
        Use the search and filters below to find RISE catalog records and items.
      </p>
      <ol class="c-help__list">
        <li class="c-oli c-oli--1">
          Narrow the list of records using one or more of the following methods.
          <ol class="c-help__list">
            <li class="c-oli c-oli--2">
              SEARCH: Enter search terms into the search bar and submit
              (<span class="c-search-button c-search-button--example c-search-button--refresh"></span>)
              the search.
            </li>
            <li class="c-oli c-oli--2">
              FILTERS: Choose (<input
                type="checkbox"
                checked="checked"
                aria-label="Example Filter Option Checkbox"
              >) and apply
              (<span class="c-search-button c-search-button--example c-search-button--filter c-search-button--refresh"></span>)
              filters.
            </li>
          </ol>
        </li>
        <li class="c-oli c-oli--1">
          Use the dropdown (<span class="c-expands__icon c-expands__icon--example collapsed"></span>)
          to quickly view the items associated with each record.
        </li>
        <li class="c-oli c-oli--1">
          Click on a record or item title to get to its details page.
        </li>
      </ol>
      {{yield}}
    </div>
  </template>
}
